import TablePagination from './tablePagination';

export default TablePagination;
